export const LANGUAGE_KEY = 'language' as const
export const AUTH_KEY = 'auth' as const
